/** @jsxImportSource @emotion/react */
import { useEffect, useState } from 'react'
import SwitcherStyle from './IDSSwitcherStyle'
import IDSSwitcherList from './IDSSwitcherList'
import ArrowDown from 'apollo-react-icons/ArrowDown'
import ClickAwayListener from '@mui/material/ClickAwayListener'

const IDSSwitcher = ({ tenant, image, tenantsIncluded }) => {
  const [showDropdownFilter, setShowDropdownFilter] = useState(false)
  const [isSwitcherActive, setSwitcherActive] = useState(false)
  const [imageLoadFailed, setImageLoadFailed] = useState(false)

  useEffect(() => {
    setImageLoadFailed(false)
  }, [image])

  const showSignInImage =
    image && !image.endsWith('missing.png') && !imageLoadFailed

  const toggleSwitcher = () => {
    setSwitcherActive(!isSwitcherActive)
  }

  const handleClickAway = () => {
    if (!isSwitcherActive) return
    setSwitcherActive(false)
  }

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div
        data-testid="switcher"
        onMouseLeave={() => setShowDropdownFilter(false)}
        css={[SwitcherStyle]}
      >
        {showSignInImage && (
          <div
            css={SwitcherStyle.selectedNetworkImageContainer}
            onClick={toggleSwitcher}
          >
            {
              <img
                css={SwitcherStyle.selectedNetworkImage}
                src={image}
                alt={tenant}
                onError={() => setImageLoadFailed(true)}
              ></img>
            }
          </div>
        )}

        {showSignInImage ? (
          <div css={SwitcherStyle.selectedNetworkName} onClick={toggleSwitcher}>
            {tenant}
          </div>
        ) : (
          <div
            css={SwitcherStyle.selectedNetworkNameNoImage}
            onClick={toggleSwitcher}
          >
            {tenant}
          </div>
        )}

        <div css={SwitcherStyle.dropDownIcon} onClick={toggleSwitcher}>
          <ArrowDown></ArrowDown>
        </div>
        <div
          css={{ alignSelf: 'flex-start', flexGrow: 4, cursor: 'pointer' }}
          onClick={toggleSwitcher}
        ></div>
        <IDSSwitcherList
          setShowDropdownFilter={setShowDropdownFilter}
          showDropdownFilter={showDropdownFilter}
          isSwitcherActive={isSwitcherActive}
          tenantsIncluded={tenantsIncluded}
        />
      </div>
    </ClickAwayListener>
  )
}

export default IDSSwitcher
